import React, { useState } from 'react';
import { Button, Checkbox, Dialog, DialogContent, MenuItem, Select } from '@material-ui/core';

import { warehouseApi } from 'api/warehouse';

const UNSLOTTED_ITEM_OOS_REASONS = [
    'Vendor Short - Case Short, Ct/Cs discrepancy',
    'Inventory Accuracy (Ops related)',
    'Inventory Accuracy (Planning related)',
    'Gapping',
    'Late Truck',
    'Quality Issue - Rejection, QC pull',
    'No more inventory on hand',
    'Late Truck - DLVD',
    'Other',
];

function UnslottedItemOosToggle({ disabled, getData, packGroupID, sellableItemId, setNotification, unslottedItemOOS }) {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState('');

    const refreshItems = () => getData({ packGroupID });

    return (
        <>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={() => setOpen(false)}>
                <DialogContent>
                    <h3>Select Reason</h3>
                    <Select
                        required
                        style={{ minWidth: 200 }}
                        value={reason}
                        SelectDisplayProps={{ 'aria-label': 'Unslotted item out of stock reason' }}
                        onChange={(e) => setReason(e.target.value)}
                    >
                        {UNSLOTTED_ITEM_OOS_REASONS.map((item) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                    <br />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!reason}
                        onClick={async () => {
                            const res = await warehouseApi.updateUnslottedItemOOS(sellableItemId, {
                                unslottedItemOOS: true,
                                unslottedItemOOSReason: reason,
                            });
                            if (res.status === true) {
                                await refreshItems();
                                setNotification({
                                    text: 'Unslotted Item marked Out of Stock',
                                    level: 'success',
                                });
                            } else {
                                setNotification({
                                    text: res.msg || 'Could not mark unslotted item as Out of Stock',
                                    level: 'error',
                                });
                            }
                            setOpen(false);
                        }}
                    >
                        Confirm Reason
                    </Button>
                </DialogContent>
            </Dialog>
            <Checkbox
                disabled={disabled}
                checked={unslottedItemOOS}
                color="primary"
                inputProps={{ 'aria-label': 'Unslotted Item Out Of Stock' }}
                onChange={async (e) => {
                    if (!unslottedItemOOS) {
                        e.preventDefault();
                        setOpen(true);
                        return;
                    }

                    const res = await warehouseApi.updateUnslottedItemOOS(sellableItemId, {
                        unslottedItemOOS: false,
                    });
                    if (res.status === true) {
                        await refreshItems();
                    } else {
                        setNotification({
                            text: res.msg || 'Could not clear unslotted item Out of Stock',
                            level: 'error',
                        });
                    }
                }}
            />
        </>
    );
}

function UnslottedItemOosCell({ column, row }) {
    return (
        <UnslottedItemOosToggle
            disabled={row.original.slot !== null || row.original.externalSku >= 300000}
            getData={column.getData}
            packGroupID={column.packGroupID}
            sellableItemId={row.original.id}
            setNotification={column.setNotification}
            unslottedItemOOS={row.original.unslottedItemOOS}
        />
    );
}

export { UnslottedItemOosCell, UnslottedItemOosToggle };
